import gsap from 'gsap'
import React, { useEffect, useRef } from 'react'

interface AnimatedDivProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  from: gsap.TweenVars
  to: gsap.TweenVars
}

export default function AnimatedDiv(props: AnimatedDivProps) {
  const ref = useRef<HTMLDivElement>(null)
  const { from, to, ...restProps } = props

  useEffect(() => {
    // Function to animate the element
    function animateElement(element: Element) {
      gsap.fromTo(
        element,
        { ...from }, // Initial state
        { ...to } // Final state
      )
    }

    // Create an Intersection Observer
    let running = false
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !running) {
          running = true
          // If element is in view, animate it
          animateElement(entry.target)
          observer.unobserve(entry.target)
          observer.disconnect()
        }
      })
    })

    // Only run on client-side
    if (typeof window !== 'undefined' && ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [from, to])

  return <div ref={ref} {...restProps} />
}
